import { useEffect, useState, useRef } from "react";
import { parseRRULE } from "../../util/helpers.js";

export const useRuleInitialiser = (
  rule,
  setAmount,
  setInitialAmount,
  setPeriodicity,
  deliver_listing,
  deliver_order,
  intl,
  fromSettings
) => {
  const [parsedRule, setParsedRule] = useState(null);
  const hasInitialized = useRef(false);
  const [options, setOptions] = useState([
    {
      label: intl.formatMessage({
        id:
          fromSettings || (rule && !rule.is_temporary)
            ? "noLongerDeliver"
            : "onceOnly",
      }),
      value: "ONCE",
      default_recurrence_key: "Once",
    },
    {
      label: intl.formatMessage({ id: "everyWeek" }),
      value: "RRULE:FREQ=WEEKLY",
      default_recurrence_key: "weekly",
    },
    {
      label: intl.formatMessage({ id: "every2Weeks" }),
      value: "RRULE:FREQ=WEEKLY;INTERVAL=2",
      default_recurrence_key: "biweekly",
    },
    {
      label: intl.formatMessage({ id: "every4Weeks" }),
      value: "RRULE:FREQ=WEEKLY;INTERVAL=4",
      default_recurrence_key: "monthly",
    },
  ]);

  const getDefaultRecurrenceValue = (defaultRecurrence) => {
    const option = options.find(
      (opt) => opt.default_recurrence_key === defaultRecurrence,
    );
    return option ? option.value : "ONCE";
  };

  const initializeFromRule = () => {
    const parsed = parseRRULE(rule.periodicity);
    let periodicityValue = `RRULE:FREQ=${parsed.frequency}`;
    if (parsed.interval !== 1) {
      periodicityValue += `;INTERVAL=${parsed.interval}`;
    }
    setAmount(rule.temporary_amount);
    setInitialAmount(rule.temporary_amount);
    setPeriodicity(periodicityValue);

    return parsed;
  };

  const initializeFromDefaults = () => {
    const rrValue = getDefaultRecurrenceValue(
      deliver_listing.default_recurrence,
    );
    setPeriodicity(rrValue);
    if (deliver_order) {
      setAmount(deliver_order.num_portions_in_cart);
      setInitialAmount(deliver_order.num_portions_in_cart);
    }
  };

  useEffect(() => {
    if (hasInitialized.current) return;
    if (rule && rule.periodicity) {
      const parsedRule = initializeFromRule();
      setParsedRule(parsedRule);
    } else {
      initializeFromDefaults();
    }
    hasInitialized.current = true;
  }, [rule, fromSettings, deliver_order, deliver_listing, intl]);

  return { options, setOptions, parsedRule };
};
